import CollapsibleBlock from "./CollapsibleBlock";

export default CollapsibleBlock;
